import type { MainObj, JimoTrackerSdkData, Options, SessionStoreData, Parameters } from './type';
import { initFromUrl, initFromStorage, setDeviceId } from './init';
import Router from './router';
import { createBodyClick, createWindowUnload, createDocumentVisibilityChange } from './event';
import {
  createBlockExposure,
  refreshBlockExposure,
  createHideElementExposure,
  refreshHideElementExposure,
} from './observer';
import { getQueryString, getValidPath, consoleLogStyle } from './utils';
import { trackInfo } from './lib';

class Tracker {
  private _mainObj: MainObj; // 请求对象
  private readonly _options: Options; // 配置参数
  public refreshBlockExposure: any; // 刷新模块曝光
  public refreshHideElementExposure: any; // 刷新隐藏元素曝光
  private _touchStartClientY: number; // 触摸滑动事件clientY
  public router: any; // 路由对象
  public sessionStore: SessionStoreData; // sdk 存储到 sessionStorage 数据
  public preEventData: any; // 上一次埋点的数据
  constructor(options: Options) {
    this._mainObj = {
      track_url: options.trackUrl, // 上报地址
      env_name: options.envName, // dev,test,test2,test3,uat,gray,prod
      device_id: '', // 浏览器设备id
      open_id: '',
      union_id: '',
      user_id: '', // 企微后台用户userId
      main_id: '', // 我们后台区别用户
      user_type: '', // 用户类型：企业员工、企业客户、潜在客户、游客
      identity: '', // 身份类型 非同事，同事，员工自己
      corp_id: '',
      staff_id: '',
      sdk_type: options.sdkType, // sdk类型
      sdk_ver: options.sdkVer, // sdk版本
      app_ver: options.appVer, // 日期+hash
      app_sub_ver: '', // 子版本
      start_source: options.startSource, // 入口
      session_id: '', // 会话id
      sub_session_id: '', // 隐藏后重新显示 会话子id
      event_type: '', // 事件类型
      project_desc: options.projectDesc, // 项目路径
      page_desc: '', // 当前页面路径
      block_desc: '', // 模块
      button_desc: '', // button
      page_title: '', // 页面名称
      parameters: {
        event_seq: -1,
        router_seq: -1,
        pre_project_desc: '',
        pre_page_desc: '',
        pre_block_desc: '',
        pre_button_desc: '',
        pre_button_t: '',
        project_desc: options.projectDesc,
        page_title: '', // 页面名称
      }, // 附加参数
    };
    this._options = options;
    this._touchStartClientY = 0;
    this.router = new Router(this);
    this.sessionStore = {}; // sdk存储到sessionStorage数据
    this.preEventData = {};
    this.refreshBlockExposure = refreshBlockExposure.bind(this);
    this.refreshHideElementExposure = refreshHideElementExposure.bind(this);
    this.init();
  }

  /**
   * 初始化
   */
  private async init() {
    initFromStorage(this); // 初始化顺序会覆盖
    initFromUrl(this);
    this.router.init(); // 在storage初始化后
    await setDeviceId(this);
    createWindowUnload(this);
    createDocumentVisibilityChange(this);
    this._options.enableBodyClick && createBodyClick(this);
    this._options.enableBlockExposure && createBlockExposure(this);
    this._options.enableHideElementExposure && createHideElementExposure(this);
  }

  public get options() {
    return this._options;
  }

  /**
   * 触摸滑动事件touchStart
   */
  public touchStart = (e: any) => {
    try {
      if (!this._options.enableTouchSlide) {
        return;
      }
      this._touchStartClientY = e.touches[0]?.clientY;
    } catch { }
  };

  /**
   * 触摸滑动事件touchEnd
   */
  public touchEnd = (e: any, dom: any, data: JimoTrackerSdkData) => {
    try {
      if (!this._options.enableTouchSlide) {
        return;
      }
      if (Math.abs(e.changedTouches[0]?.clientY - this._touchStartClientY) > 50) {
        let scrollTop = dom.scrollTop;
        if (scrollTop === 0 && dom.style.transform) {
          // 当是transform滑动，获取Y轴数值
          scrollTop = Math.abs(parseInt(dom.style.transform?.split(',')[1]?.split('px')[0]));
        }
        this.sendTracker({
          ...data,
          parameters: { ...data.parameters, scrollTop } as Parameters,
        });
      }
    } catch { }
  };

  /**
   * 设置埋点数据方法
   */
  public setData(obj: MainObj) {
    try {
      this._mainObj = { ...this._mainObj, ...obj, parameters: { ...this._mainObj.parameters, ...obj.parameters } };
    } catch { }
  }

  /**
   * 冷启动发送埋点
   */
  public coldStart() {
    try {
      if (this._mainObj?.start_source) {
        if (this._options.enableLog) {
          console.log('%c[jimo-tracker-sdk]', consoleLogStyle, `cold_start`);
        }
        this.sendTracker({
          event_type: 'cold_start',
          block_desc: '',
          button_desc: '',
        });
      }
    } catch { }
  }

  /**
   * 获取当前路径
   */
  public getSpmPathName() {
    try {
      return getValidPath(location.pathname).slice(this._mainObj?.project_desc?.length);
    } catch (error) {
      console.log('getSpmPathName error:', error);
    }
    return '';
  }

  public getFirstShareData() {
    const shareData: any = {};
    console.log(this.sessionStore.firstShare, 55555555);
    if (this.sessionStore.firstShare) {
      const firstShare = decodeURIComponent(this.sessionStore.firstShare) || undefined;
      const firstShareArr = firstShare ? firstShare.split('_') : [];
      console.log(firstShareArr, 'vue项目77777777777777777');
      if (firstShareArr.length) {
        console.log('hhhhh埋点啦', firstShareArr);
        shareData.first_share_sess_id = firstShareArr[0] || 0;
        shareData.first_share_event_seq = firstShareArr[1] || 0;
        shareData.first_share_type = firstShareArr[2] || 0;
        shareData.first_share_t = firstShareArr[3] || 0;
      }
    }

    return shareData;
  }

  public getPreShareData() {
    const shareData: any = {};

    if (this.sessionStore.preShare) {
      const preShare = decodeURIComponent(this.sessionStore.preShare) || undefined;
      const preShareArr = preShare ? preShare.split('.') : [];
      if (preShareArr.length) {
        shareData.pre_share_sess_id = preShareArr[0];
        shareData.pre_share_event_seq = preShareArr[1];
        shareData.pre_share_type = preShareArr[2];
        shareData.pre_share_t = preShareArr[3];
        shareData.inviter_id = preShareArr[4];
      }
    }

    return shareData;
  }

  /**
   * 自定义埋点上报方法
   */
  public async sendTracker(data: JimoTrackerSdkData): Promise<number> {
    try {
      // 最近一次的上报数据将用于页面跳转时的 preSpm 参数
      this.preEventData = data;

      // 删除 page_desc 字段
      delete data.page_desc;

      // 一期临时来源方案，业务里未删除，所以保留
      if (data.parameters?.enterBtnTargetPath) {
        delete data.parameters.enterBtnTargetPath;
      }

      // 设置会话全局自增 ID
      this._mainObj.parameters.event_seq++;
      if (typeof this.sessionStore.eventSeq === 'number') {
        this.sessionStore.eventSeq++;
      }

      // 分享数据
      data.parameters = {
        ...data.parameters,
        ...this.getFirstShareData(),
        ...this.getPreShareData(),
      } as Parameters;

      if (!this._mainObj.device_id) {
        await setDeviceId(this);
      }
      const trackData: any = {
        ...this._mainObj,
        ...data,
        parameters: {
          ...this._mainObj.parameters,
          ...data.parameters,
        },
      };

      trackData.page_desc = getValidPath(this._mainObj.page_desc);
      trackData.page_title = document.title;
      trackData.parameters.page_title = trackData.page_title;

      if (!trackData?.staff_id) {
        trackData.staff_id = getQueryString('staffId');
      }

      if (this._options.enableLog) {
        console.log('%c[jimo-tracker-sdk]', consoleLogStyle, `trackData`, JSON.stringify(trackData, null, 2));
      }

      if (this._options.nodeEnv === 'production') {
        trackInfo(trackData);
      }

      return this._mainObj.parameters.event_seq;
    } catch (error) {
      console.error('sendTracker error: ', error);
      return -1;
    }
  }
}

export default Tracker;
